import { DriverUser } from '../../types/driverAuth';
import {
  AuthTokenBundle,
  clearAuthTokenBundle,
  getAccessToken,
  saveAuthTokenBundle,
} from './authTokens';

const DRIVER_AUTH_TOKEN_KEY = 'shiftwagon_driver_auth_token';
const DRIVER_AUTH_USER_KEY = 'shiftwagon_driver_auth_user';

export function saveDriverAuthToken(token: string): void {
  saveAuthTokenBundle('driver', { accessToken: token });
}

export function getDriverAuthToken(): string | null {
  return getAccessToken('driver');
}

export function saveDriverAuthTokens(bundle: AuthTokenBundle): void {
  saveAuthTokenBundle('driver', bundle);
}

export function clearDriverAuthToken(): void {
  clearAuthTokenBundle('driver');
  sessionStorage.removeItem(DRIVER_AUTH_TOKEN_KEY);
}

export function saveDriverAuthUser(user: DriverUser): void {
  sessionStorage.setItem(DRIVER_AUTH_USER_KEY, JSON.stringify(user));
}

export function getDriverAuthUser(): DriverUser | null {
  const raw = sessionStorage.getItem(DRIVER_AUTH_USER_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as DriverUser;
  } catch {
    return null;
  }
}

export function clearDriverAuthUser(): void {
  sessionStorage.removeItem(DRIVER_AUTH_USER_KEY);
}

export function clearDriverAuthFlow(): void {
  clearDriverAuthToken();
  clearDriverAuthUser();
}
